export const WaitPromise = (timeOut: number) =>
    new Promise<void>((res, rej) => {
        setTimeout(() => {
            res();
        }, timeOut);
    });
